// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-align-right {
  text-align: right;
}

.text-align-center {
  text-align: center;
}

.deleted, .disabled {
  font-style: italic;
  color: #a9a9a9 !important;
}

.div-border {
  border: 1px solid lightgrey;
}

.div-border-left {
  border-left: 1px solid lightgrey;
}

.div-border-top {
  border-top: 1px solid lightgrey;
}

.div-border-left-top {
  border-left: 1px solid lightgrey;
  border-top: 1px solid lightgrey;
}

.div-border-left-top-right {
  border-left: 1px solid lightgrey;
  border-top: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
}

.div-border-all {
  border-left: 1px solid lightgrey;
  border-top: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-left-right {
  border-left: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
}

.div-border-right {
  border-right: 1px solid lightgrey;
}

.div-border-top-right {
  border-top: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
}

.div-border-right-bottom {
  border-right: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-top-right-bottom {
  border-top: 1px solid lightgrey;
  border-right: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom {
  border-bottom: 1px solid lightgrey;
}

.div-border-top-bottom {
  border-top: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom-left {
  border-left: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom-left-right {
  border-right: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom-left-top {
  border-top: 1px solid lightgrey;
  border-left: 1px solid lightgrey;
  border-bottom: 1px solid lightgrey;
}

.div-border-bottom-left-top-right {
  border: 1px solid lightgrey;
}

.div-text-center {
  text-align: center;
}

.borderless {
  border: 0;
}

::ng-deep table.table-quotation-list th, table.table-quotation-list th {
  padding: 1rem 0.25rem 1rem 0.5rem !important;
  font-size: smaller;
  border-width: 1px !important;
}
::ng-deep table.table-quotation-list td, table.table-quotation-list td {
  padding: 0.65rem 0.5rem !important;
  font-size: smaller;
}
::ng-deep table.table-quotation-list td a, table.table-quotation-list td a {
  color: var(--primary-light);
  text-decoration: none;
}
::ng-deep table.table-quotation-list td a:hover, table.table-quotation-list td a:hover {
  color: var(--primary-light);
  text-decoration: underline;
}
::ng-deep table.table-quotation-list td a:visited, table.table-quotation-list td a:visited {
  color: var(--primary-light);
}
::ng-deep table.table-quotation-list tr:last-child td, table.table-quotation-list tr:last-child td {
  border-bottom: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/secure/dashboard/rfqs/rfq/rfq.component.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,yBAAA;AACD;;AAEA;EACC,2BAAA;AACD;;AAEA;EACC,gCAAA;AACD;;AAEA;EACC,+BAAA;AACD;;AAEA;EACC,gCAAA;EACA,+BAAA;AACD;;AAEA;EACC,gCAAA;EACA,+BAAA;EACA,iCAAA;AACD;;AAEA;EACC,gCAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;AACD;;AAEA;EACC,gCAAA;EACA,iCAAA;AACD;;AAEA;EACC,iCAAA;AACD;;AAEA;EACC,+BAAA;EACA,iCAAA;AACD;;AAEA;EACC,iCAAA;EACA,kCAAA;AACD;;AAEA;EACC,+BAAA;EACA,iCAAA;EACA,kCAAA;AACD;;AAEA;EACC,kCAAA;AACD;;AAEA;EACC,+BAAA;EACA,kCAAA;AACD;;AAEA;EACC,gCAAA;EACA,kCAAA;AACD;;AAEA;EACC,iCAAA;EACA,gCAAA;EACA,kCAAA;AACD;;AAEA;EACC,+BAAA;EACA,gCAAA;EACA,kCAAA;AACD;;AAEA;EACC,2BAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,SAAA;AACD;;AAIE;EACC,4CAAA;EACA,kBAAA;EACA,4BAAA;AADH;AAGE;EACC,kCAAA;EACA,kBAAA;AADH;AAGG;EACC,2BAAA;EACA,qBAAA;AADJ;AAEI;EACC,2BAAA;EACA,0BAAA;AAAL;AAEI;EACC,2BAAA;AAAL;AAMI;EACC,8BAAA;AAJL","sourcesContent":[".text-align-right {\n\ttext-align: right;\n}\n\n.text-align-center {\n\ttext-align: center;\n}\n\n.deleted, .disabled {\n\tfont-style: italic;\n\tcolor: #a9a9a9 !important;\n}\n\n.div-border {\n\tborder: 1px solid lightgrey;\n}\n\n.div-border-left {\n\tborder-left: 1px solid lightgrey;\n}\n\n.div-border-top {\n\tborder-top: 1px solid lightgrey;\n}\n\n.div-border-left-top {\n\tborder-left: 1px solid lightgrey;\n\tborder-top: 1px solid lightgrey;\n}\n\n.div-border-left-top-right {\n\tborder-left: 1px solid lightgrey;\n\tborder-top: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n}\n\n.div-border-all {\n\tborder-left: 1px solid lightgrey;\n\tborder-top: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-left-right {\n\tborder-left: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n}\n\n.div-border-right {\n\tborder-right: 1px solid lightgrey;\n}\n\n.div-border-top-right {\n\tborder-top: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n}\n\n.div-border-right-bottom {\n\tborder-right: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-top-right-bottom {\n\tborder-top: 1px solid lightgrey;\n\tborder-right: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom {\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-top-bottom {\n\tborder-top: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom-left {\n\tborder-left: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom-left-right {\n\tborder-right: 1px solid lightgrey;\n\tborder-left: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom-left-top {\n\tborder-top: 1px solid lightgrey;\n\tborder-left: 1px solid lightgrey;\n\tborder-bottom: 1px solid lightgrey;\n}\n\n.div-border-bottom-left-top-right {\n\tborder: 1px solid lightgrey;\n}\n\n.div-text-center {\n\ttext-align: center;\n}\n\n.borderless {\n\tborder: 0;\n}\n\n::ng-deep table, table {\n\t&.table-quotation-list {\n\t\tth {\n\t\t\tpadding: 1rem 0.25rem 1rem 0.5rem !important;\n\t\t\tfont-size: smaller;\n\t\t\tborder-width: 1px !important;\n\t\t}\n\t\ttd {\n\t\t\tpadding: 0.65rem 0.5rem !important;\n\t\t\tfont-size: smaller;\n\n\t\t\ta {\n\t\t\t\tcolor: var(--primary-light);\n\t\t\t\ttext-decoration: none;\n\t\t\t\t&:hover {\n\t\t\t\t\tcolor: var(--primary-light);\n\t\t\t\t\ttext-decoration: underline;\n\t\t\t\t}\n\t\t\t\t&:visited {\n\t\t\t\t\tcolor: var(--primary-light);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ttr {\n\t\t\t&:last-child {\n\t\t\t\ttd {\n\t\t\t\t\tborder-bottom: none !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
